export const FACEBOOK_USER = 'Facebook'
export const GOOGLE_USER = 'Google'
export const APPLE_USER = 'SignInWithApple'
